import { Component, Input, OnInit } from '@angular/core';
import { interval, map, Observable } from 'rxjs';

@Component({
  selector: 'app-show-timer',
  templateUrl: './show-timer.component.html',
  styleUrls: ['./show-timer.component.css']
})
export class ShowTimerComponent implements OnInit {
  @Input() initialValue: string; // Input property for initial time value
  timer$: Observable<string>;

  constructor() { }

  ngOnInit(): void {
    console.log(this.initialValue,'initialValue');

    if(this.initialValue){
     // Parse the initial value and calculate total seconds
     const initialSeconds = this.parseTimeString(this.initialValue);

     this.timer$ = interval(1000).pipe(
       map((secondsPassed) => this.formatTime(initialSeconds + secondsPassed ))
     );
    }
  }

  formatTime(totalSeconds: number): string {
    const hours = this.padNumber(Math.floor(totalSeconds / 3600));
    const minutes = this.padNumber(Math.floor((totalSeconds % 3600) / 60));
    const seconds = this.padNumber(totalSeconds % 60);
    return `${hours}:${minutes}:${seconds}`;
  }

  parseTimeString(timeString: string): number {
    const [hours, minutes, seconds] = timeString.split(':').map(Number);
    return hours * 3600 + minutes * 60 + seconds;
  }

  padNumber(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

}
